function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "exclaim-line-path"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.971-4.729.027-15.791a1.779,1.779,0,0,1,1.661-2.084L4.1-18a1.778,1.778,0,0,1,1.865,1.892L5.234-4.91a.534.534,0,0,1-.5.5l-2.205.123a.532.532,0,0,1-.555-.441",
  transform: "translate(0 18)",
  fill: "none",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "exclaim-point-path"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.6-3.429A1.744,1.744,0,0,1,5.489-1.807a1.722,1.722,0,0,1-1.7,1.8,1.738,1.738,0,0,1-1.892-1.6A1.76,1.76,0,0,1,3.6-3.429",
  transform: "translate(-1.891 3.432)",
  fill: "none",
  clipRule: "evenodd"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-483 -525)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 15,
  transform: "translate(483 525)",
  fill: "#8354ba"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(495 549)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 -18)",
  clipPath: "url(#exclaim-line-path)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-5-23H11.641V1.382H-5Z",
  transform: "translate(-0.335 17.665)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(2.018 -2.456)",
  clipPath: "url(#exclaim-point-path)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-3.109-8.432h14.27V5.661H-3.109Z",
  transform: "translate(-2.226 3.097)",
  fill: "#fff"
}))));

var SvgReactionExclaim = function SvgReactionExclaim(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReactionExclaim, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reaction-exclaim.b70b4771.svg";
export { ForwardRef as ReactComponent };